module.exports = __webpack_public_path__ + "static/img/summer_putaoPic.6ad7a21e.png";